export default __webpack_public_path__ + "static/media/cancel.744ea61b.svg";